import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { apiLogin } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Eye, EyeOff } from "lucide-react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await apiLogin(email, password);
      login(data.access_token, data.user);
      toast.success("Benvenuto!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        {/* Back to home */}
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 mb-8">
          <ArrowLeft className="w-4 h-4" /> Torna alla home
        </Link>

        {/* Logo */}
        <div className="flex items-center gap-1 mb-8">
          <span className="font-serif text-2xl font-bold text-foreground">Io</span>
          <span className="font-serif text-2xl font-bold text-accent">Ci</span>
          <span className="font-serif text-2xl font-bold text-foreground">Sono</span>
          <span className="text-xs text-muted-foreground font-sans ml-0.5">.org</span>
        </div>

        <Card className="bg-card border-border/40 shadow-elevated">
          <CardContent className="p-8">
            <h1 className="font-serif text-2xl font-bold text-foreground mb-2">Accedi</h1>
            <p className="text-sm text-muted-foreground mb-8">Bentornato. Inserisci le tue credenziali.</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" placeholder="tuo@email.it" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <div className="relative">
                  <Input id="password" type={showPw ? "text" : "password"} placeholder="La tua password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors">
                    {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <Button type="submit" variant="premium" size="lg" className="w-full" disabled={loading}>
                {loading ? "Accesso in corso..." : "Accedi"}
              </Button>
            </form>

            <p className="text-sm text-muted-foreground text-center mt-6">
              Non hai un account?{" "}
              <Link to="/register" className="text-accent font-medium hover:underline">Registrati</Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
